import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { size, color } from './helpers/variables';
import { hideOnPrint } from './helpers/mixins';

export const Container = styled.div`
  width: 100%;
  max-width: ${props => (props.fullWidth ? '100%' : '1580px')};
  padding-top: ${props => (props.swipe ? '0' : '2rem')};
  padding-bottom: ${props => (props.swipe ? '0' : '2rem')};
  padding-left: calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.xLarge} - ${size.small}))));
  padding-right: calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.xLarge} - ${size.small}))));
  margin: 0 auto;
  position: ${props => (props.positionRelative ? 'relative' : 'initial')};
  margin-bottom: ${props => (props.mb ? `${props.mb}px` : 0)};
  background-color: ${props => (props.bgColor ? color.black : 'transparent')};

  ${props =>
    props.sticky &&
    css`
      position: fixed;
      z-index: 150;
      top: 0;
      width: 100%;
    `};

  @media screen and (max-width: ${size.small}px) {
    padding-left: 8px;
    padding-right: 8px;
  }

  @media screen and (min-width: ${size.xLarge}px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  ${props =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}

  ${props =>
    props.noPadding &&
    css`
      padding-top: 0;
      padding-bottom: 0;
    `}

  ${props =>
    props.noXPadding &&
    css`
      padding-left: 0 !important;
      padding-right: 0 !important;
    `}

  ${props =>
    props.noPaddingTop &&
    css`
      padding-top: 0 !important;
    `}

  ${props =>
    props.noPaddingBottom &&
    css`
      padding-bottom: 0 !important;
    `}

  ${props =>
    props.padded &&
    css`
      padding-top: 4rem;
      padding-bottom: 4rem;
    `}

  ${props =>
    props.pb &&
    css`
      padding-bottom: ${props.pb}px;
    `}

  ${props =>
    props.pt &&
    css`
      padding-top: ${props.pt}px;
    `}

    ${props =>
      props.bgImg &&
      css`
        background: url(${props.bgImg});
        background-position: center;
        background-size: cover;
      `}

  ${props => props.hideOnPrint && hideOnPrint};

  ${props =>
    props.productPage &&
    css`
      padding-top: 0;
      padding-bottom: 60px;
    `}
  ${props =>
    props.productPageFirst &&
    css`
      padding-top: 20px;
    `}

  ${props =>
    props.productPageMobileFirst &&
    css`
      margin: 10px 0 -30px;
    `}
`;

Container.propTypes = {
  padded: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/styles/Container.js